import { useCustomerPortalUserRoleAssignmentsQuery } from './useCustomerPortalUserRoleAssignmentsQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface CpUserRoleRevokeMutationParams {
  assignmentId: string;
}

export const useCustomerPortalUserRoleRevokeMutation = createMutationHook(
  'settings.customerPortal.userRoleRevoke',
  (params: CpUserRoleRevokeMutationParams) => ({
    coreUserRoleRevoke: {
      __args: {
        id: params.assignmentId,
      },
      id: true,
    },
  }),
  {
    invalidateQueries: [useCustomerPortalUserRoleAssignmentsQuery],
  },
);
